import { useI18n } from "@/contexts/i18n";
import { PlayCircleIcon, PlayIcon, ThreeDimensionalFilledIcon, } from "@gemini/icons";
export const useMediaOverlay = (media) => {
    const { t } = useI18n();
    if (media.urlType === "VIRTUAL_TOUR") {
        return {
            tagText: t("richMedia.preview.3dTour.tag"),
            tagIcon: ThreeDimensionalFilledIcon,
            buttonIcon: ThreeDimensionalFilledIcon,
        };
    }
    return {
        tagText: t("richMedia.preview.video.tag"),
        tagIcon: PlayCircleIcon,
        buttonIcon: PlayIcon,
    };
};
